import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Popover, Tooltip } from 'antd';
import { useCrud } from 'react-structure-admin';
import NotificationList from './NotificationList';

const MyNotifications = ({ iconClassName = '' }) => {
  const crud = useCrud({
    resource: 'notifications',
    endpoint: 'notifications/my-notifications',
    fixedQueryParams: { onlyIsActive: true }
  });

  const { data, fetch } = crud;

  if (!data.loaded && !data.loading) {
    fetch();
  }

  return (
    <Tooltip title="Notificações">
      <Popover
        openClassName="gx-mynotifications"
        overlayClassName="gx-my-notifications"
        content={() => <NotificationList {...crud} />}
        trigger="click"
      >
        <Badge className="gx-m-0" count={data.notVisualizedCount} size="small">
          <FontAwesomeIcon
            className={`${iconClassName} icon gx-text-white gx-pointer`}
            icon="bell"
            onBlur
          />
        </Badge>
      </Popover>
    </Tooltip>
  );
};

export default MyNotifications;
